var React = require('react');

function ArrowLong (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M9 .875A8.125 8.125 0 1017.125 9 8.134 8.134 0 009 .875zm3.125 8.75H7.384l1.584 1.585a.625.625 0 11-.884.883l-2.65-2.65a.627.627 0 010-.886l2.65-2.65a.625.625 0 01.884.884L7.384 8.375h4.741a.625.625 0 110 1.25z","fill":"currentColor"}));
}

ArrowLong.defaultProps = {"width":"18","height":"18","fill":"none","viewBox":"0 0 18 18"};

module.exports = ArrowLong;

ArrowLong.default = ArrowLong;
